import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { ArrowLeft, Sparkles } from 'lucide-react';

function ExaminationAssistantPage() {
  const [role, setRole] = useState('advocate');
  const [transcript, setTranscript] = useState('');
  const [suggestion, setSuggestion] = useState('');
  const [aiLoading, setAiLoading] = useState(false);
  const [showResult, setShowResult] = useState(false);

  const handleAnalyze = async () => {
    if (!transcript.trim()) {
      Swal.fire('Peringatan', 'Mohon masukkan transkrip pemeriksaan.', 'warning');
      return;
    }

    setAiLoading(true);
    setSuggestion('');
    setShowResult(false);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/examination-assist/generate`,
        { transcript, role },
        { withCredentials: true }
      );

      setSuggestion(response.data.question || 'Tidak ada saran yang dihasilkan.');
      setShowResult(true);
    } catch (err) {
      Swal.fire('Gagal', err.response?.data?.error || 'Terjadi kesalahan saat memproses transkrip.', 'error');
    } finally {
      setAiLoading(false);
    }
  };

  const handleBackToForm = () => {
    setShowResult(false);
    setSuggestion('');
  };

  return (
    <div className="tw w-full px-2 py-4">
      <div className="mx-auto max-w-4xl">
        <div className="mb-8 text-center">
          <h2 className="text-3xl font-semibold text-slate-800">Examination Assistant</h2>
          <p className="mt-2 text-sm text-slate-500">Bantu Anda menyusun pertanyaan berdasarkan transkrip pemeriksaan.</p>
        </div>

        {!showResult && !aiLoading ? (
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <div className="mb-4">
              <label className="mb-2 block text-sm font-semibold text-slate-700">Peran Anda</label>
              <select
                className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value="advocate">Advokat Pembela</option>
                <option value="prosecutor">Jaksa Penuntut Umum (JPU)</option>
                <option value="judge">Hakim</option>
              </select>
            </div>

            <div className="mb-5">
              <label className="mb-2 block text-sm font-semibold text-slate-700">Transkrip Pemeriksaan</label>
              <textarea
                className="min-h-[220px] w-full resize-y rounded-xl border border-slate-300 px-3 py-3 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                placeholder="Tempelkan atau ketik transkrip pemeriksaan saksi di sini..."
                value={transcript}
                onChange={(e) => setTranscript(e.target.value)}
              />
            </div>

            <button
              type="button"
              className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white hover:bg-slate-800"
              onClick={handleAnalyze}
              disabled={aiLoading}
            >
              <Sparkles size={16} />
              Dapatkan Saran Pertanyaan
            </button>
          </div>
        ) : null}

        {aiLoading && !showResult ? (
          <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 text-sm text-slate-600">Menganalisis transkrip...</p>
          </div>
        ) : null}

        {showResult ? (
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h5 className="mb-4 text-lg font-semibold text-slate-800">Saran Pertanyaan</h5>
            <blockquote className="rounded-xl bg-slate-50 p-5 text-slate-700">
              <p className="text-xl italic leading-relaxed">"{suggestion}"</p>
            </blockquote>

            <button
              type="button"
              className="mt-5 inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
              onClick={handleBackToForm}
            >
              <ArrowLeft size={15} />
              Kembali
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default ExaminationAssistantPage;
